export default {"src":"/_next/static/media/user-default.a835d400.svg","height":30,"width":30};